/* eleReady.js */
(function (win) {
    "use strict";
    var listeners = [],
    doc = win.document,
    MutationObserver = win.MutationObserver || win.WebKitMutationObserver,
    observer;
    function ready(selector, fn) {
    // Store the selector and callback to be monitored
    listeners.push({
        selector: selector,
        fn: fn,
    });
    if (!observer) {
        // Watch for changes in the document
        observer = new MutationObserver(check);
        observer.observe(doc.documentElement, {
        childList: true,
        subtree: true,
        });
    }
    // Check if the element is currently in the DOM
    check();
    }
    function check() {
    // Check the DOM for elements matching a stored selector
    for (
        var i = 0, len = listeners.length, listener, elements;
        i < len;
        i++
    ) {
        listener = listeners[i];
        // Query for elements matching the specified selector
        elements = doc.querySelectorAll(listener.selector);

        for (var j = 0, jLen = elements.length, element; j < jLen; j++) {
        element = elements[j];
        // Make sure the callback isn't invoked with the
        // same element more than once
        if (!element.ready) {
            element.ready = "select";
            // Invoke the callback with the element
            listener.fn.call(element, element);
        }
        }
    }
    }
    win.eleReady = ready;
})(this);

/*  
if ( window.location.pathname.includes('/collections/') ) {
  eleReady('.product-item', (el) => {
    const variantPopup = el.querySelector('.card .variants-popup-content');
    const atcForm = el.querySelector('.card-action form');
    const atcButton = atcForm?.querySelector('.button') || atcForm?.querySelector('button');
    const atcTitleLink = el.querySelector('.card-title')?.getAttribute('href');
    const customAtcButton = el?.querySelector('button.CP-atc-btn'); // Specific button selector

    if (!variantPopup && atcForm && atcButton && atcTitleLink) {
      const cleanHref = atcTitleLink.split('?')[0];
      const cardActions = el.querySelector('.card-action') || el.querySelector('.card-actions');

      if (cardActions) {
        cardActions.insertAdjacentHTML('afterbegin', `<a href="${cleanHref}" class="button custom-atc-link">${atcButton.textContent}</a>`);
      }

      atcForm.classList.add('visually-hidden');
      atcButton.removeAttribute('data-btn-addtocart');
      atcButton.removeAttribute('data-available');
      // ✅ Create anchor element
      customAtcButton.remove();
      el.querySelector('.CP-action-btn').insertAdjacentHTML('beforeend', `<a href="${cleanHref}" class="CP-customatc-btn custom-atc-link">${atcButton.textContent}</a>`);
    }
  });
}
*/
if (window.location.pathname.includes('/collections/')) {
  eleReady('.product-item', (el) => {
    try {
      // Scope to card (fallback to element itself)
      const card = el.querySelector('.card') || el;

      // Key nodes
      const variantPopup = card.querySelector('.variants-popup-content');
      const atcForm = card.querySelector('.card-action form, .card-actions form');
      const atcButton = atcForm?.querySelector('button, .button');

      // Get product link from possible title variants
      const titleEl = el.querySelector('.card-title a, .card-title');
      const atcTitleLink =
        titleEl?.getAttribute?.('href') || titleEl?.href || null;

      // Existing custom button that we want to replace (may not exist)
      const customAtcButton = el.querySelector('button.CP-atc-btn');

      // Don’t duplicate if we’ve already inserted a custom link
      const alreadyHasCustomLink = el.querySelector('.custom-atc-link');

      if (!variantPopup && atcForm && atcButton && atcTitleLink && !alreadyHasCustomLink) {
        const cleanHref = atcTitleLink.split('?')[0];

        // Prefer explicit CP action area → then card action containers → then form parent → lastly the card itself
        const cpAction = el.querySelector('.CP-action-btn');
        const cardActions =
          card.querySelector('.card-action') ||
          card.querySelector('.card-actions');
        const insertTarget =
          cpAction || cardActions || atcForm?.parentElement || card;

        // If cardActions exists, also mirror a link at its start (matches original behavior)
        if (cardActions) {
          const label = (atcButton.textContent || '').trim() || 'View details';
          cardActions.insertAdjacentHTML(
            'afterbegin',
            `<a href="${cleanHref}" class="button custom-atc-link">${label}</a>`
          );
        }

        // Hide the native ATC form and neutralize button data-attrs
        atcForm.classList.add('visually-hidden');
        atcButton?.removeAttribute?.('data-btn-addtocart');
        atcButton?.removeAttribute?.('data-available');

        // Remove the specific custom button only if it exists
        if (customAtcButton && customAtcButton.isConnected) {
          customAtcButton.remove();
        }

        // Insert our CP-styled custom link in the preferred CTA container
        const label2 = (atcButton.textContent || '').trim() || 'View details';
        insertTarget.insertAdjacentHTML(
          'beforeend',
          `<a href="${cleanHref}" class="CP-customatc-btn custom-atc-link">${label2}</a>`
        );
      }
    } catch (err) {
      // Fail-safe per card to avoid breaking the whole listing
      console.warn('CP custom ATC setup failed for a card:', err);
    }
  });
}